import React, { useEffect } from 'react';
import cl from './RefundPolicy.module.css';
import { Link, animateScroll as scroll } from "react-scroll";



const RefundPolicy = (props) => {
useEffect(() => {
  scroll.scrollToTop();
}, []);

    
    return (
      <section className={cl.app_policy}>
        <h1>Politica di Rimborso</h1>
        <p>Ultimo aggiornamento: 07 febbraio 2024</p>
        <h2>Cancellazione</h2>
        <p>
          Accettiamo la cancellazione dell'ordine prima che il prodotto venga
          spedito o prodotto. Se l'ordine viene cancellato, riceverai un
          rimborso completo. Non possiamo cancellare l'ordine se il prodotto è
          già stato spedito.
        </p>

        <h2>Resi (se applicabile)</h2>
        <p>
          Accettiamo il reso dei prodotti. I clienti hanno il diritto di
          richiedere un reso entro 14 giorni dalla ricezione del prodotto.
          <br />
          Per essere idoneo a un reso, il tuo articolo deve essere non
          utilizzato e nello stesso stato in cui lo hai ricevuto. Deve anche
          essere nella confezione originale. Per completare il reso, è
          necessario un documento fiscale o una prova d'acquisto. Si prega di
          non restituire il tuo acquisto al produttore o alla nostra stazione di
          transito.
        </p>
      </section>
    );
}

export default RefundPolicy;
